import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useCallback, useRef, useState } from 'react';
import { SimpleCache } from '../../utils/simple-cache';
import { useDecorateWithResultAndAPISetState } from './use-decorate-with-result-and-api-set-state';
import { ExperiencePerformanceTypes, ExperienceTypes } from '@atlassian/ufo';
import { COMPONENT, UFOExperienceOneTime } from '../../common/ufo-experiences';

/**
 * This decorator adds capabilities of API state tracking and caching to the plain PreQuerySupplier.
 * Think of this as an internal private method of useProductStateMachine.
 *
 * @returns A cached implementation of PreQuery Supplier which is also aware of setting its respective API state.
 */
export var usePreQueryDecorator = function usePreQueryDecorator(_ref) {
  var preQueryItemSupplier = _ref.preQueryItemSupplier,
    setAPIState = _ref.setAPIState,
    setState = _ref.setState,
    id = _ref.id;
  var _useState = useState(new SimpleCache(preQueryItemSupplier)),
    _useState2 = _slicedToArray(_useState, 1),
    preQueryCache = _useState2[0];
  var searchItemSupplier = useCallback(function (args) {
    return preQueryCache.getAsync(args).value;
  }, [preQueryCache]);
  var ufoPreQueryLoadExperience = useRef(new UFOExperienceOneTime("".concat(id, "-pre-query-results-load"), {
    type: ExperienceTypes.Experience,
    performanceType: ExperiencePerformanceTypes.InlineResult,
    platform: {
      component: COMPONENT
    }
  }));
  return useDecorateWithResultAndAPISetState({
    setState: setState,
    setAPIState: setAPIState,
    searchItemSupplier: searchItemSupplier,
    ufoExperience: ufoPreQueryLoadExperience.current
  });
};